<template>
    <div class="car-quote-step select-coverage">
        <quote-step-header
            :title="subStepFields.title"
            :key="currentSubStep"
            :subtitle="subStepFields.subtitle"
        ></quote-step-header>

        <!-- <div class="car-quote-guide">{{ trans("guide") }}</div> -->

        <!-- 3 BUTTONS -->

        <form class="quote-form" @submit.prevent="next">
            <!-- חובה -->
            <div class="form-row center">
                <!-- <app-text-checkbox
          v-model="form[stepName].mandatory"
          :disabled="true"
          :label="trans('types.mandatory')"
        >
        </app-text-checkbox> -->

                <!-- מקיף / צד ג -->
                <app-text-radio-buttons
                    v-model="form[stepName].optional"
                    :items="optionalInsurance"
                    :breakMobile="true"
                >
                </app-text-radio-buttons>
            </div>

            <div class="form-row center">
                <div class="error-message" v-if="errors.get('mandatory')">
                    {{ errors.get("mandatory") }}
                </div>
                <div class="error-message" v-if="errors.get('optional')">
                    {{ errors.get("optional") }}
                </div>
            </div>

            <div class="submit-row">
                <app-button :disabled="disabledConditions" :loading="loading">
                    {{ "quote.welcome.next" | __ }}
                </app-button>
            </div>
        </form>
        <!-- form end -->
    </div>
</template>

<script>
import QuoteStep from "../../../mixins/QuoteStep";

export default {
    name: "CarQuoteSelectCoverage",

    mixins: [QuoteStep],

    props: {},

    data() {
        return {
            subSteps: ["default"],
            chosenInsurance: []
        };
    },

    mounted() {
        this.$on("input", form => {
            this.calculateChosenInsurance(form);
        });

        this.$nextTick(() => {
            this.calculateChosenInsurance();
        });
    },

    methods: {
        calculateChosenInsurance(form = null) {
            const coverage = form
                ? form[this.stepName]
                : this.form[this.stepName];
            const chosen = [];

            if (coverage.mandatory) {
                chosen.push(
                    `${this.trans("insurance")} ${this.trans(
                        "types.mandatory"
                    )}`
                );
            }

            if (coverage.optional) {
                chosen.push(
                    `${this.trans("insurance")} ${this.trans(
                        `types.${coverage.optional}`
                    )}`
                );
            }

            this.chosenInsurance = chosen;
        }
    },

    computed: {
        canMoveNext() {
            const mandatory = this.stepFormFields.mandatory;
            const optional = this.stepFormFields.optional;
            const possibleOptional = [
                this.constants.OPTIONAL_COMPREHENSIVE,
                this.constants.OPTIONAL_THIRD_PARTY
            ];

            return mandatory && possibleOptional.includes(optional);
        },
        optionalInsurance() {
            return [
                {
                    label: this.trans("types.com_mandatory"),
                    value: this.constants.OPTIONAL_COMPREHENSIVE
                },
                {
                    label: this.trans("types.3rd_mandatory"),
                    value: this.constants.OPTIONAL_THIRD_PARTY
                }
            ];
        },
        chosenInsuranceText() {
            const chosenText = this.trans("chosen");

            return chosenText.replace(/\$/, this.chosenInsurance.join(", "));
        }
    }
};
</script>

<style lang="scss" scoped>
.select-coverage {
    max-width: $quote-step-width;
}
</style>
